import React, { useId, useState } from 'react';
import { ListItemIcon, ListItemText, Menu, MenuItem } from '@mui/material';
import { DeleteOutline, EditOutlined } from '@mui/icons-material';
import { User } from '../../types';
import { useLanguage } from '../../contexts/LanguageContext';
import RowActionsButton from '../common/RowActionsButton';

interface UserActionsMenuProps {
  user: User;
  canDelete: boolean;
  onEdit: (user: User) => void;
  onDelete: (user: User) => void;
}

const UserActionsMenu: React.FC<UserActionsMenuProps> = ({ user, canDelete, onEdit, onDelete }) => {
  const { t } = useLanguage();
  const id = useId();
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const open = Boolean(anchorEl);
  const close = () => setAnchorEl(null);

  return (
    <>
      <RowActionsButton
        id={`${id}-button`}
        aria-label={`${t('common.actions')}: ${user.firstName} ${user.lastName}`}
        aria-haspopup="menu"
        aria-expanded={open}
        aria-controls={open ? `${id}-menu` : undefined}
        onClick={event => setAnchorEl(event.currentTarget)}
      />
      <Menu id={`${id}-menu`} anchorEl={anchorEl} open={open} onClose={close} slotProps={{ list: { 'aria-labelledby': `${id}-button` } }}>
        <MenuItem onClick={() => { close(); onEdit(user); }}>
          <ListItemIcon><EditOutlined fontSize="small" /></ListItemIcon>
          <ListItemText>{t('common.edit')}</ListItemText>
        </MenuItem>
        {canDelete && <MenuItem onClick={() => { close(); onDelete(user); }} sx={{ color: 'error.main' }}>
          <ListItemIcon sx={{ color: 'inherit' }}><DeleteOutline fontSize="small" /></ListItemIcon>
          <ListItemText>{t('common.delete')}</ListItemText>
        </MenuItem>}
      </Menu>
    </>
  );
};

export default UserActionsMenu;
